import { render, staticRenderFns } from "./MainCategoryBox.vue?vue&type=template&id=4e2eaf5c&scoped=true&"
import script from "./MainCategoryBox.vue?vue&type=script&lang=js&"
export * from "./MainCategoryBox.vue?vue&type=script&lang=js&"
import style0 from "./MainCategoryBox.vue?vue&type=style&index=0&id=4e2eaf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2eaf5c",
  null
  
)

export default component.exports